import * as React from "react";
import { StyledBottomNav } from "./styles";
import assets from "../../assets/index";
import { useLocation, useNavigate } from "react-router-dom";

export const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navOptions = [
    {
      id: "/home",
      iconSrc: assets.HomeIcon,
      onClick: () => navigate("/home"),
    },
    {
      id: "/reservations",
      iconSrc: assets.ReservationsNavIcon,
      onClick: () => navigate("/reservations"),
    },
    {
      id: "/explore",
      iconSrc: assets.FeedIcon,
      onClick: () => navigate("/explore"),
    },
    {
      id: "/inbox",
      iconSrc: assets.InboxIcon,
      onClick: () => navigate("/inbox"),
    },
  ];

  return (
    <StyledBottomNav>
      {navOptions.map((opt) => (
        <div
          key={opt.id}
          onClick={opt.onClick}
          style={{
            opacity: location.pathname === opt.id ? 1 : 0.5,
          }}
        >
          <img alt={opt.id} src={opt.iconSrc} />
        </div>
      ))}
    </StyledBottomNav>
  );
};
